module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAgAgMAAABMV+HwAAAADFBMVEUAgP8YkP8YkP8YkP+nEf39AAAAA3RSTlMGiO5KE2VQAAAAHUlEQVQI12OQcmCov8Cw/wHD/w/UREADgcZKOQAAqUE41woajz0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/icons/rect.png
// module id = GDvq
// module chunks = 1